"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PinterestSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 30, viewBox: "0 0 30 30" }, props),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", { transform: "translate(-214 -743) translate(214 743)" },
                    react_1.default.createElement("circle", { cx: 15, cy: 15, r: 12, fill: "#FFF" }),
                    react_1.default.createElement("path", { fill: "#BD081C", d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm.25 6C10.418 6 6.5 9.922 6.5 14.759c0 3.605 2.177 6.702 5.286 8.046-.023-.61-.001-1.338.153-1.999.159-.665 1.007-4.26 1.12-4.737l.011-.053s-.28-.561-.28-1.391c0-1.301.755-2.275 1.693-2.275.8 0 1.185.601 1.185 1.32 0 .804-.512 2.006-.776 3.119-.22.932.469 1.694 1.387 1.694 1.663 0 2.782-2.14 2.782-4.675 0-1.926-1.294-3.369-3.652-3.369-2.663 0-4.325 1.99-4.325 4.211 0 .766.227 1.307.58 1.724.163.192.185.27.126.49l-.031.121-.08.316c-.026.108-.05.207-.067.27-.058.222-.24.3-.44.218-1.226-.5-1.799-1.845-1.799-3.357 0-2.498 2.104-5.492 6.277-5.492 3.353 0 5.56 2.43 5.56 5.035 0 3.45-1.916 6.025-4.739 6.025-.948 0-1.84-.513-2.144-1.095 0 0-.512 2.024-.619 2.416-.184.668-.54 1.335-.868 1.86.765.22 1.573.337 2.41.337 4.832 0 8.75-3.922 8.75-8.759S20.082 6 15.25 6z" })))));
}
function Pinterest(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PinterestSvg, Object.assign({}, svgProps)));
}
exports.default = Pinterest;
//# sourceMappingURL=Pinterest.js.map